import { useOnboardingStoreV2 } from '@forwardflow/store/onboardingStoreV2'
import { Card, StepHeader } from '../shell/Card'
import { PaymentDetails } from './PaymentDetails'

/**
 * Step 3, second screen: the card. The form itself is the existing payment
 * step (summary of what is charged today and monthly, Stripe card, consents,
 * Back and Subscribe), under a header that says what is about to happen.
 */
export const Payment = () => {
   const { onboardingData } = useOnboardingStoreV2()
   const { isSubscriptionActivated, pricingData } = onboardingData
   const budget = pricingData?.maxSpend ?? 150
   return (
      <div className="space-y-4">
         <Card className="!space-y-0">
            <StepHeader
               title={isSubscriptionActivated ? 'Your subscription is active' : 'Add your card'}
               lede={
                  isSubscriptionActivated
                     ? 'Payment is set up. Continue to confirm the rest of your setup.'
                     : `Today we charge your seats plus a starting balance for calls. After that it is your seats every month, plus whatever tops the balance back up to $${budget}. You can see the exact amounts below.`
               }
            />
         </Card>
         <PaymentDetails />
      </div>
   )
}
